var _defs, _path, _polygon, _polygon2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.32 30.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcb116;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.33,23.11A1.34,1.34,0,0,0,29,24.79l-2.37,2.37a1.36,1.36,0,0,0-.69,0l-1.7-1.7a1.33,1.33,0,1,0-2.57,0l-3,3a1.33,1.33,0,1,0,.95.95l3-3a1.36,1.36,0,0,0,.69,0L25,28.1a1.33,1.33,0,1,0,2.57,0L30,25.73a1.33,1.33,0,1,0,.34-2.62Z",
    transform: "translate(-11.84 -6.36)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.49 17.42 15.12 16.04 16.49 15.42 15.12 14.8 14.49 13.42 13.88 14.8 12.49 15.42 13.88 16.04 14.49 17.42"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.83 18.75 7.16 17.42 8.49 17.08 7.16 16.75 6.83 15.42 6.49 16.75 5.16 17.08 6.49 17.42 6.83 18.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,6.36H14.88a3,3,0,0,0-3,3l0,24.32a3,3,0,0,0,3,3H33.12a3,3,0,0,0,3-3V15.48ZM14.88,33.73V9.4H25.52V17h7.6V33.73Z",
    transform: "translate(-11.84 -6.36)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.046ed244fe0785149f9b9a8ae745267b.svg";
export { ForwardRef as ReactComponent };